type HorizontalAlignment = 'left' | 'center' | 'right'

export interface EditorialItemThemeInterface {
  twoItemEditorial: {
    horizontalAlignment: HorizontalAlignment
  }
  threeItemEditorial: {
    horizontalAlignment: HorizontalAlignment
  }
  editorialWithFeature: {
    horizontalAlignment: HorizontalAlignment
  }
}

// TODO: REBUILD-5407: Add this to Artemis so that it can
//       changed on a site-by-site basis
export const EditorialItemTheme: EditorialItemThemeInterface = {
  twoItemEditorial: {
    horizontalAlignment: 'center',
  },
  threeItemEditorial: {
    horizontalAlignment: 'center',
  },
  editorialWithFeature: {
    horizontalAlignment: 'center',
  },
}
